stimulusApp.register(
  "search--panel",
  class extends Stimulus.Controller {
    static outlets = ["search--form"]

    #pendingCollapse = false

    #onFixerFixed = (_e, selector) => {
      if (selector !== "place-search-inner") return
      // Keep the form expanded while a sub-pane is open so it isn't ripped away
      // mid-interaction; collapse once the pane closes.
      if (this.#anyPaneOpen()) {
        this.#pendingCollapse = true
        return
      }
      this.element.classList.remove("search-panel-desktop--form_visible")
      this.#closeFormPane()
    }

    #onFixerReleased = (_e, selector) => {
      if (selector !== "place-search-inner") return
      this.#pendingCollapse = false
      this.element.classList.add("search-panel-desktop--form_visible")
    }

    #onPaneClosed = () => {
      if (!this.#pendingCollapse) return
      this.#pendingCollapse = false
      this.element.classList.remove("search-panel-desktop--form_visible")
    }

    connect() {
      $(document).on("fixer:fixed", this.#onFixerFixed)
      $(document).on("fixer:released", this.#onFixerReleased)
      this.element.addEventListener(
        "hb:search-form:pane-closed",
        this.#onPaneClosed,
      )
    }

    disconnect() {
      $(document).off("fixer:fixed", this.#onFixerFixed)
      $(document).off("fixer:released", this.#onFixerReleased)
      this.element.removeEventListener(
        "hb:search-form:pane-closed",
        this.#onPaneClosed,
      )
    }

    #anyPaneOpen() {
      return (
        this.hasSearchFormOutlet &&
        Boolean(this.searchFormOutlet.activePaneValue)
      )
    }

    #closeFormPane() {
      if (!this.hasSearchFormOutlet) return
      this.searchFormOutlet.closePane()
    }
  },
)
